import { useState, type FC } from 'react';
import { LuSparkles, LuArrowRight } from 'react-icons/lu';
import './BrikNovidadeGanhas.css';

/** A pergunta que o botão manda — a mesma que a pessoa escreveria. */
export const PERGUNTA_REVISAR_FUNIL = 'Revise meu funil pelas conversas e me diga o que mudou';

/** Depois disto o aviso some sozinho, testado ou não. */
const ATE = new Date('2026-12-15T23:59:59');

const CHAVE = 'lemeia:novidade-vendas-ganhas';

/**
 * O aviso da varredura de vendas ganhas, na Home (21/10/2026).
 *
 * Fica **na fala do Brik**, não no campo de escrever: o composer é só escrever
 * e enviar (decisão dele em 24/09, quando o popover e o link saíram de lá).
 * Aqui o Brik conta a novidade e oferece a pergunta pronta — é ele falando,
 * que é o que a Home já faz.
 *
 * Some de três jeitos: depois de testar, depois de dispensar e, de qualquer
 * forma, na data em que deixa de ser novidade. Aviso que fica para sempre vira
 * enfeite, e enfeite ninguém lê.
 */
const BrikNovidadeGanhas: FC<{ onTestar: (pergunta: string) => void }> = ({ onTestar }) => {
    const [visivel, setVisivel] = useState(() => {
        if (new Date() > ATE) return false;
        try {
            return localStorage.getItem(CHAVE) !== 'visto';
        } catch {
            /* Navegador sem storage (aba anônima travada): mostrar é melhor que sumir. */
            return true;
        }
    });

    if (!visivel) return null;

    const encerrar = () => {
        try {
            localStorage.setItem(CHAVE, 'visto');
        } catch {
            /* Sem storage o aviso volta no próximo carregamento; não é motivo para falhar. */
        }
        setVisivel(false);
    };

    return (
        <div className="hc-nov">
            <div className="hc-nov-k">
                <LuSparkles size={13} /> Novo
            </div>

            <div className="hc-nov-t">
                Agora eu leio as conversas e organizo o seu funil
            </div>

            <div className="hc-nov-d">
                Acho as vendas que já fecharam, as que ficaram para trás no funil e as conversas que
                nem são negócio — sempre com a frase que prova. Você decide o que fazer em cada uma.
            </div>

            <button
                type="button"
                className="hc-nov-p"
                onClick={() => {
                    encerrar();
                    onTestar(PERGUNTA_REVISAR_FUNIL);
                }}
            >
                <span>“{PERGUNTA_REVISAR_FUNIL}”</span>
                <span className="hc-nov-cta">Testar <LuArrowRight size={14} /></span>
            </button>

            <button type="button" className="hc-nov-x" onClick={encerrar}>
                Agora não
            </button>
        </div>
    );
};

export default BrikNovidadeGanhas;
